import React from 'react';
import { useSelector } from 'react-redux';
import { ActionButton, DialogTrigger, Flex, Item, Picker, useDialogContainer, View, } from '@adobe/react-spectrum';
import { EditorActions } from 'app/stores/editor/actions';
import { ProjectActions } from 'app/stores/project/actions';
import { getPagesCount } from 'app/stores/selectors';
import { useAppDispatch } from 'app/stores/store';
import { Text } from 'app/views/components/typography/Text';
import { analytics } from 'app/utils/analytics';
import { saveToDevice } from 'app/utils/download';
import { isDevel } from 'app/utils/varia';
const DownloadPopover = () => {
    const dispatch = useAppDispatch();
    const dialog = useDialogContainer();
    const hasMutiplePages = useSelector((state) => getPagesCount(state) > 1);
    const [exportStrategy, setExportStrategy] = React.useState(hasMutiplePages ? 'all_pages' : 'current_page');
    const onDownload = React.useCallback((type) => {
        analytics({
            action: 'ExportAction',
            label: 'download',
        });
        dispatch(ProjectActions.rasterizeProject(Object.assign({ strategy: exportStrategy, generateManifest: isDevel }, type)))
            .unwrap()
            .then(blob => {
            dialog.dismiss();
            return saveToDevice(blob);
        })
            .then(() => dispatch(EditorActions.showToast({
            message: 'Project exported successfuly',
            variant: 'positive',
        })));
    }, [dialog, exportStrategy, dispatch]);
    const onDownloadPNG = React.useCallback(() => onDownload({
        format: 'image/png',
    }), [onDownload]);
    const onDownloadJPEG = React.useCallback(() => onDownload({
        format: 'image/jpeg',
    }), [onDownload]);
    React.useEffect(() => {
        setExportStrategy(hasMutiplePages ? 'all_pages' : 'current_page');
    }, [hasMutiplePages, setExportStrategy]);
    const headerText = exportStrategy === 'current_page'
        ? 'Download image as'
        : 'Download zipped as';
    return (React.createElement(View, { padding: "size-200" },
        React.createElement(Flex, { direction: "column", gap: "size-100" },
            React.createElement(Picker, { label: "Download", isHidden: !hasMutiplePages, selectedKey: exportStrategy, onSelectionChange: option => setExportStrategy(option) },
                React.createElement(Item, { key: "all_pages" }, "All slides"),
                React.createElement(Item, { key: "current_page" }, "Only current slide")),
            React.createElement(Text, { size: "S" }, headerText),
            React.createElement(ActionButton, { "data-test-id": "download-png", height: "size-800", onPress: onDownloadPNG },
                React.createElement(Flex, { direction: "column" },
                    React.createElement(Text, null, "PNG"),
                    React.createElement(Text, { size: "XS" }, "Higher quality image"))),
            React.createElement(ActionButton, { "data-test-id": "download-jpeg", height: "size-800", onPress: onDownloadJPEG },
                React.createElement(Flex, { direction: "column" },
                    React.createElement(Text, null, "JPEG"),
                    React.createElement(Text, { size: "XS" }, "Smaller file size"))))));
};
export const Download = () => (React.createElement(DialogTrigger, { type: "popover", hideArrow: true },
    React.createElement(ActionButton, { "data-test-id": "header-download", isQuiet: true }, "Download"),
    React.createElement(DownloadPopover, null)));
